import { RateFinderWidgetState, RateFinderCriteria, RateFinderResult } from "app/pages/AgentPricing/modules/RateFinderWidget/state";


function getRoot(state: any) : RateFinderWidgetState {
    return state.rateFinder;
}

export function getRateFinderCriteria(state: any) : RateFinderCriteria {
    return getRoot(state).criteria; 
}

export function getRateFinderResult(state: any) : RateFinderResult {
    return getRoot(state).result; 
}